import React from "react";
import { Button } from "component-library";

interface EditSectionActionsProps {
  onSave: () => void;
  onCancel: () => void;
  saveDisabled: boolean;
  saveLabel: string;
  cancelLabel: string;
  isSaving?: boolean;
}

const EDIT_SECTION_SAVE_CLASS =
  "profile-header-edit-section__save !h-[2.0625rem] !min-h-[2.0625rem] !w-auto !min-w-0 !rounded-[0.625rem] !border-0 !px-3 !py-[0.375rem] !text-sm !normal-case !bg-color-brand-one !text-white hover:!bg-color-brand-one/90 dark:!bg-color-brand-one dark:!text-white dark:hover:!bg-color-brand-one/90";
const EDIT_SECTION_CANCEL_CLASS =
  "profile-header-edit-section__cancel !h-[2.0625rem] !min-h-[2.0625rem] !w-auto !min-w-0 !rounded-[0.625rem] !border !border-white/[0.18] !bg-white/15 !px-3 !py-[0.375rem] !text-sm !normal-case !text-grey-void hover:!bg-white/20 dark:!border-white/[0.18] dark:!bg-white/15 dark:!text-white dark:hover:!bg-white/20";

const EditSectionActions = ({
  onSave,
  onCancel,
  saveDisabled,
  saveLabel,
  cancelLabel,
  isSaving = false,
}: EditSectionActionsProps) => (
  <div className="mt-2 flex gap-2">
    <Button
      type="primary"
      text={saveLabel}
      onClick={onSave}
      disabled={saveDisabled}
      className={EDIT_SECTION_SAVE_CLASS}
    />
    <Button
      type="secondary"
      text={cancelLabel}
      onClick={onCancel}
      disabled={isSaving}
      className={EDIT_SECTION_CANCEL_CLASS}
    />
  </div>
);

export default EditSectionActions;
